var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ConnectionNames } from "../../../Contracts";
import { ConfigStore, getClientType, getRequestProps } from "../../../Common";
import { getExtSessionId } from "../../../App/Auth";
import * as RequestBYMC from "./RequestsByMessageChannels";
export function BetSlipRequestFormatter(message) {
    let body;
    const { baseUrl, endpoint, method, headers, params } = getRequestProps(ConnectionNames.betslip, message);
    const clientType = getClientType(ConfigStore.config.device.type);
    headers["Content-Type"] = "application/json-patch+json";
    if (typeof clientType !== "undefined") {
        headers["ClientType"] = clientType;
    }
    if (getExtSessionId()) {
        headers["seamlessadditionaldata"] = `&extsessionid=${getExtSessionId()}`;
    }
    if (typeof params !== "undefined") {
        if (method === "GET") {
            return getRequest(message, method, params, headers, baseUrl, endpoint);
        }
        const { meta } = params, rest = __rest(params, ["meta"]);
        if (typeof meta !== "undefined") {
            headers["metadata"] = JSON.stringify(meta);
        }
        body = JSON.stringify(rest);
    }
    return new Request(`${baseUrl}${endpoint}`, {
        method,
        headers,
        body
    });
}
function getRequest(message, method, params, headers, baseUrl, endpoint) {
    return typeof RequestBYMC[message.name] === "function" ? RequestBYMC[message.name](method, params, headers, baseUrl, endpoint)
        : new Request(`${baseUrl}${endpoint}`, {
            method,
            headers
        });
}
//# sourceMappingURL=BetSlipRequestFormatter.js.map